import React from "react";
import { Box } from "@material-ui/core";
import SkeletonGrid from "common/UI/Skeleton/SkeletonGrid";
import SkeletonTitle from "common/UI/Skeleton/SkeletonTitle";

export default function WalletPageSkeleton() {
  return (
    <>
      <Box mb={5}>
        <SkeletonTitle />
        <SkeletonGrid col={2} row={1} rowHeight={200} />

        <SkeletonTitle />
        <SkeletonGrid col={4} row={5} rowHeight={10} />
      </Box>
    </>
  );
}
